import { LANGUAGES } from "../constants";

export const generateLocalizedPaths = (basePath = "") =>
  LANGUAGES.map((lang) => `${lang}${basePath}`);
